import { useState, useEffect } from 'react';
import { VehicleSelectionForm, SelectedVehicle } from './VehicleSelectionForm.js';
import { SavedVehicle, getSavedVehicles, addSavedVehicle, removeSavedVehicle } from '../vehicleHistory.js';
import { ProductType } from '../state/modalStore.js';

interface VehicleSelectorProps {
  invalidVehicle: Partial<SavedVehicle> | null;
  showHistory: boolean;
  ptype?: ProductType;
}

export function VehicleSelector({ invalidVehicle, showHistory, ptype }: VehicleSelectorProps) {
  const [savedVehicles, setSavedVehicles] = useState<SavedVehicle[]>([]);

  const isClearance = (ptype === "clearance");

  useEffect(() => {
    if (invalidVehicle) {
      removeSavedVehicle(invalidVehicle);
      // After removing, re-fetch the list to update the UI
      setSavedVehicles(getSavedVehicles());
    }
  }, [invalidVehicle]); // eslint-disable-line react-hooks/exhaustive-deps

  useEffect(() => setSavedVehicles(getSavedVehicles()), []);

  const handleVehicleSelect = (vehicle: SelectedVehicle) => {
    const vehicleToSave: SavedVehicle = {
      makeName: vehicle.makeName,
      modelName: vehicle.modelName,
      year: vehicle.year,
      makeSlug: vehicle.makeSlug,
      modelSlug: vehicle.modelSlug,
    };

    // Save the selection and update state
    addSavedVehicle(vehicleToSave);
    setSavedVehicles(getSavedVehicles());

    // Redirect to the fitment page
    const uroot = ptype === "clearance" ? "/clearance-fitment" : "/fitment";
    window.location.href = `${uroot}/${vehicle.makeSlug}/${vehicle.modelSlug}/${vehicle.year}/`;
  };

  const handleSavedVehicleClick = (vehicle: SavedVehicle) => {
    addSavedVehicle(vehicle); // Move to top of the list
    const uroot = ptype === "clearance" ? "/clearance-fitment" : "/fitment";
    window.location.href = `${uroot}/${vehicle.makeSlug}/${vehicle.modelSlug}/${vehicle.year}/`;
  };

  return (
    <div className="gbrakes-vehicle-selector">
      {showHistory && savedVehicles.length > 0 && (
        <div className="gbs-saved-vehicles">
          <h4 className="gbs-saved-vehicles-title">Recent Searches</h4>
          <ul className="gbs-saved-vehicles-list">
            {savedVehicles.map((vehicle, index) => (
              <li key={index}>
                <button type="button" className="gbs-saved-vehicle-button" onClick={() => handleSavedVehicleClick(vehicle)}>
                  {vehicle.year} {vehicle.makeName} {vehicle.modelName}
                </button>
              </li>
            ))}
          </ul>
          <hr className="gbs-separator" />
        </div>
      )}
      <VehicleSelectionForm onVehicleSelect={handleVehicleSelect} ptype={ptype} submitButtonText="Find Parts" />
    </div>
  );
}
